import {useContext, useEffect, useState} from "react";
import {Dialog, DialogContent, DialogTitle, IconButton, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ConfigContext from "../context/ConfigContext";

const PopupManager = () => {
    const {config} = useContext(ConfigContext);
    const [open, setOpen] = useState(false);
    const [currentPopup, setCurrentPopup] = useState(null);

    useEffect(() => {
        if (config?.popups?.length > 0) {
            // Get closed popup IDs from localStorage
            const closedPopups = JSON.parse(localStorage.getItem('closedPopups') || '[]');
            
            // Find first popup that hasn't been closed
            const popupToShow = config.popups.find(popup => !closedPopups.includes(popup.id));
            
            if (popupToShow) {
                setCurrentPopup(popupToShow);
                setOpen(true);
            }
        }
    }, [config?.popups]);

    const handleClose = () => {
        setOpen(false);
        if (currentPopup) {
            // Add popup ID to closed popups in localStorage
            const closedPopups = JSON.parse(localStorage.getItem('closedPopups') || '[]');
            if (!closedPopups.includes(currentPopup.id)) {
                closedPopups.push(currentPopup.id);
                localStorage.setItem('closedPopups', JSON.stringify(closedPopups));
            }
        }
    };

    if (!currentPopup) return null;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <Typography variant="h6">{currentPopup.name}</Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <div dangerouslySetInnerHTML={{ __html: currentPopup.description }} />
            </DialogContent>
        </Dialog>
    );
};

export default PopupManager; 